import { Select, MenuItem, Tooltip, FormControl, InputLabel } from "@mui/material";

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import Loader from "../../components/Loader";
import { CrossIcon, DotMenuIcon } from "../../assets/Icons";
import { IMAGE_URL } from "../../Api/constants";
import { useSelector } from "react-redux";
import Modal from "../../components/Modal";
import { toast } from "react-toastify";
import { getRequest, postRequest } from "../../Api";
import { routes } from "../../Api/routes";

import DataTable from "../../components/DataTable";
import ActionMenu from "../../components/ActionMenu";
import { citiesOman } from '../../data/citiesOman'

const Stores = () => {

  const navigate = useNavigate();
  const words = useSelector((state) => state.authReducer.words);
  const lang = useSelector((state) => state.authReducer.lang);
  const classTextAlign = lang == 'ar' ? 'text-right' : 'text-left';
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletedStoreId, setDeletedStoreId] = useState('');

  const [loading, setLoading] = useState(false);
  const [storesList, setStoresList] = useState([]);

  const [tempData, setTempData] = useState(storesList);
  const [selectedCity, setSelectedCity] = useState("");
  const isAdmin = JSON.parse(localStorage.getItem("admin"));

  const doDeleteStore = async () => {

    setDeleteModal(false);
    setLoading(true);
    const onSuccess = () => {
      toast.success('Store deleted');
      getStores();
      // setLoading(false);
    }

    const onError = () => {
      toast.error('Error while deleting store');
      setLoading(false);
    }

    await postRequest({ id: deletedStoreId }, routes.deleteStore, true, onSuccess, onError);


  }

  const getStores = async () => {

    const onSuccess = (res) => {
      setLoading(false);
      setTempData(res.data);
      setStoresList(res.data);
    }
    const onError = (err) => {
      setLoading(false);
      toast.error('Error while fetching data');
    }

    setLoading(true);
    await getRequest('', routes.getStores, true, onSuccess, onError);
  }

  const handleFilterChange = (event) => {
    const city = event.target.value;
    setSelectedCity(city);
    if (city) {
      const filteredData = storesList.filter(store => store.city?.toLowerCase() === city.toLowerCase());
      setTempData(filteredData);
    } else {
      setTempData(storesList);
    }
  };



  useEffect(() => {
    getStores();
  }, [])




  const columns = [
    {
      title: words['no'],
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: words['store name'],
      dataIndex: 'type',
      key: 'type',
      render: (_, record) => {
        return (
          <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
            <div className="flex items-center gap-2">
              <img
                src={
                  `${IMAGE_URL}/${record?.logo}` ||
                  "/images/user1.png"
                }
                alt="userImage"
                className="h-8 w-8 rounded-full object-contain bg-gray-300"
              />
              {record.store_name}
            </div>
          </td>
        )
      }
    },
    {
      title: words['phone'],
      dataIndex: 'store_number',
      key: 'store_number',
    },
    {
      title: words['email'],
      dataIndex: 'store_email',
      key: 'store_email',
    },
    {
      title: words['id store'],
      dataIndex: 'store_id',
      key: 'store_id',
    },
    {
      title: words['location'],
      dataIndex: 'type',
      key: 'type',
      render: (_, record) => (
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          <Tooltip
            title={record.current_location}
            arrow
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                maxWidth: 100,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              }}
            >
              {record.current_location}
            </div>
          </Tooltip>
        </td>
      )
    },

    // {
    //   title: words['publishing'],
    //   dataIndex: 'publishing',
    //   key: 'publishing',
    // },
    {
      title: words['status'],
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => (
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          <div
            className={`py-2 px-2 rounded-full text-center font-semibold ${record.status == true || record.status == "true"
              ? "bg-[#0DB214]/40 text-[#0DB214]"
              : "bg-red-200 text-red-400"
              }`}
          >
            {record.status == "true" || record.status == true ? "Active" : "InActive"}
          </div>
        </td>
      )
    },
    {
      field: "Action",
      title: words["action"],
      render: (value, record) => (
        <ActionMenu
          onAction={(action) => {
            if (action == 'view') {
              return navigate(`/dashboard/store-detail/${record.store_id}`);
            }
            if (action == "edit") {
              return navigate(`/dashboard/edit-store/${record.store_id}`)
            } else if (action === "delete") {
              setDeleteModal(true);
              setDeletedStoreId(record.store_id);
            }
          }}
          menuItems={
            isAdmin?.role == 'admin' ?
              [
                { label: words['View'], action: "view" },
                { label: words['Edit'], action: "edit" },
                { label: words['Delete'], action: "delete" },
              ]
              : [{ label: words['View'], action: "view" }]
        }
        />
      ),
    }





    // {
    //   title: words["action"],
    //   key: 'action',
    //   render: (_, record) => (
    //     <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32] relative">
    //       <div className="">
    //         <div
    //           className="flex items-center justify-center cursor-pointer"
    //           onClick={(e) => {
    //             e.stopPropagation();
    //             setHide(!hide);
    //           }}
    //         >
    //           <DotMenuIcon />
    //         </div>
    //         <div
    //           className={`menuList-block flex items-center absolute ${hide ? "show" : ""
    //             }`}
    //         >
    //           <div className="menu-item flex items-center flex-col anim">
    //             <Link
    //               to={`/dashboard/store-detail/${item.store_id}`}
    //               className="slt flex items-center gap-1 justify-between text-white text-sm"
    //               onClick={(e) => {
    //                 setHide(!hide);
    //               }}
    //             >
    //               {words['View']}
    //             </Link>
    //             <Link
    //               to={`/dashboard/edit-store/${item.store_id}`}
    //               className="slt flex items-center gap-1 justify-between text-white text-sm"
    //               onClick={(e) => {
    //                 setHide(!hide);
    //               }}
    //             >
    //               {words['Edit']}
    //             </Link>
    //             <div
    //               className="slt flex items-center gap-1 justify-between text-white text-sm"
    //               onClick={(e) => {
    //                 setHide(!hide);
    //                 setDeleteModal(true);
    //                 setDeletedStoreId(item.store_id);
    //               }}
    //             >
    //               {words['Delete']}
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </td>
    //   ),
    // },
  ];


  return (
    <Layout pageTitle={words['stores']}>
      <div className="store-page min-h-screen flex">
        {loading ? (
          <div className="wrap wrapWidth flex flex-col items-center ">
            <Loader />
          </div>
        ) : (
          <div className="wrap wrapWidth flex flex-col">
            <div className="flex flex-col gap-5 mt-6">
              <div style={{ zIndex: 1 }} className="flex items-center justify-between gap-3">
                <div className="flex flex-1 justify-end">
                  <div style={{ marginRight: 5, marginLeft: 5 }}>
                    <select
                      value={selectedCity}
                      onChange={handleFilterChange}
                      className="w-48 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-themeColor focus:outline-none"
                    >
                      <option value="">All Cities</option>
                      {citiesOman.map((city, index) => (
                        <option key={index} value={city.title}>
                          {city.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  {isAdmin?.role == 'admin' &&
                    <Link
                      to="/dashboard/create-store"
                      className="!flex items-center button bg-themeColor rounded-full gap-2 !py-1 px-4 shadow-md hover:shadow-lg transition"
                    >
                      <div className="flex items-center justify-center text-white font-normal text-2xl">
                        +
                      </div>
                      <label className="text-white cursor-pointer font-medium">
                        {words['add store']}
                      </label>
                    </Link>
                  }
                </div>
              </div>
              <div style={{ marginTop: -52 }}>
                <DataTable
                  searchContainerStyle={{ width: "40%" }}
                  data={Array.isArray(tempData) ? tempData : []}
                  columns={columns}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal open={deleteModal} setOpen={setDeleteModal}>
        <div className="flex flex-col shadow-md-custom border border-[#D8D8D8] p-4">
          <div className="flex items-center justify-between gap-3">
            <h1 className="text-black text-xl font-medium">{words['Are you sure you want to delete this store?']} </h1>
            <div
              className="flex items-center justify-center h-8 w-8 bg-[#EFEFEF] rounded-full p-1 hover:cursor-pointer"
              onClick={() => setDeleteModal(false)}
            >
              <CrossIcon />
            </div>
          </div>
          <div className="flex row mt-5 justify-end " >
            <div className="flex items-center justify-center">
              <button
                className="button rounded-full !py-2 !px-10"
                onClick={(e) => doDeleteStore()}
              >
                {words['Yes']}
              </button>
            </div>
            <div className="flex items-center justify-center">
              <button
                onClick={() => setDeleteModal(false)}
                className="button rounded-full !py-2 !px-10 ml-2 "
              // onClick={(e) => submitFormData()}
              >
                {words['Cancel']}
              </button>
            </div>
          </div>

        </div>
      </Modal>

    </Layout>
  );
};

export default Stores;
